import "./select-print-card.scss";
import icon from  "./img_sample.png";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Env } from "../../../../../models/env";

type ImageProps = {
  src: string,
}

const ThumbImage = (props: ImageProps & { onClose: () => void }) => {
  const [show, setShow] = useState(false);
  const handleClose = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setShow(false);
  }, []);

  const onTransitionEnd = useCallback((e: React.TransitionEvent<HTMLDivElement>) => {
    if (!show) {
      props.onClose();
    }
  }, [show, props.onClose]);
  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <div
      className={`print_order_thumbnail_backdrop ${show ? 'show' : ''}`}
      onClick={handleClose}
      onTransitionEnd={onTransitionEnd}
    >
      <div className="print_order_thumbnail_img_cnt" onClick={(e) => e.stopPropagation()}>
        <img src={`${Env.api.back.protocol}://${Env.api.back.host}/${props.src}`} alt="" />
      </div>
    </div>
  )
}

const Image = (props: ImageProps) => {
  const {
    src,
  } = props;
  const [openThumb, setOpenThumb] = useState(false);
  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpenThumb(true);
        }}
        style={{ background: 'none', border: 'none', padding: 0, height: '100%' }}
      >
        <img
          src={`${Env.api.back.protocol}://${Env.api.back.host}/${src}`}
          alt="item_img"
        />
      </button>
      {openThumb && (
        <ThumbImage
          src={src}
          onClose={() => setOpenThumb(false)}
        />
      )}
    </>
  )
}

type ProductsResponse = {
  products: {
    productNameId: string,
    productName: string,
    productImagePath?: string,
    productDescription?: string,
  }[],
}


type Props = {
  data?: ProductsResponse['products'][0],
  isSelect: boolean,
  callback: (id: string) => void,
  unSelectable?: boolean
}

export const SelectPrintCard = (props: Props) => {
  const {
      data,
      isSelect,
      callback,
      unSelectable,
  } = props;
  const className = useMemo(() => {
    const styles = ['select_print_card'];
    if (isSelect && !unSelectable) styles.push('select_target');
    if (unSelectable) styles.push('unselectable');
    return styles.join(' ');
  }, [isSelect, unSelectable]);
  const onSelect = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (unSelectable) return;
    callback(data?.productNameId ?? '');
  }, [data, callback, unSelectable]);
  if (!data) {
    return <></>;
  }
  return (
    <div
      className={className}
      onClick={onSelect}
    >
      {/* <div className="select_print_card__check">
        <div className={`checkbox__form checked style_type_1 ${isSelect ? 'show' : ''}`} />
      </div> */}
      <Image src={data.productImagePath ?? ''} />
      <div
        className="select_print_card__description"
      >
        <div className="select_print_card__description__label">{data.productName}</div>
        {/* <div className="select_print_card__description__label">プロプリント　２５０ＳＱ（Ｆ）ラミネート加工(ソフト)</div> */}
        <div className="select_print_card__description__description">{data.productDescription ?? ''}</div>
        {/* <div className="select_print_card__description__description">●納期：中5日　／サイズ：250×250mm　面質：[光沢・ラスター]　フチ：[なし・白フチ]　ラミネート種：両面（ソフト）</div> */}
      </div>
    </div>
  )
}